module.exports = __webpack_public_path__ + "static/media/bookmarked.f4782a52.svg";